var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGraduate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 513.075 513.075",
    style: {
      enableBackground: "new 0 0 513.075 513.075"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 428.009,
    y: 36.296,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 768.95 -225.6507)",
    style: {
      fill: "#CED6E0"
    },
    width: 6.4,
    height: 20.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M414.942,37.333c0,2.133,1.067,4.267,2.133,5.333c1.067,1.067,2.133,2.133,4.267,2.133 c3.2-2.133,6.4-4.267,8.533-8.533c0-1.067-1.067-3.2-2.133-4.267c-1.067-1.067-3.2-2.133-5.333-2.133 C419.209,30.933,416.009,34.133,414.942,37.333z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.836,
    y: 21.321,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 783.672 -261.6982)",
    style: {
      fill: "#CED6E0"
    },
    width: 6.4,
    height: 20.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M429.875,22.4c0,2.133,1.067,4.267,2.133,5.333c1.067,1.067,2.133,2.133,4.267,2.133 c4.267-2.133,7.467-4.267,8.533-8.533c0-1.067-1.067-3.2-2.133-4.267c-1.067-1.067-3.2-2.133-5.333-2.133 C433.075,16,430.942,19.2,429.875,22.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.673,
    y: 6.347,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 798.4122 -297.7532)",
    style: {
      fill: "#CED6E0"
    },
    width: 6.4,
    height: 20.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M444.809,7.467c0,2.133,1.067,4.267,2.133,5.333c1.067,1.067,2.133,2.133,4.267,2.133 c3.2-2.133,6.4-4.267,8.533-8.533c0-1.067-1.067-3.2-2.133-4.267C455.475,1.067,454.409,0,452.275,0 C448.009,1.067,445.875,4.267,444.809,7.467z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.314,
    y: 42.112,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 108.7754 367.0978)",
    style: {
      fill: "#CED6E0"
    },
    width: 6.4,
    height: 20.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M513.075,60.8c0-2.133-1.067-4.267-2.133-5.333c-1.067-1.067-2.133-2.133-4.267-2.133 c-4.267,2.133-7.467,4.267-8.533,8.533c0,1.067,1.067,3.2,2.133,4.267c1.067,1.067,3.2,2.133,5.333,2.133 C508.809,67.2,512.009,65.067,513.075,60.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.692,
    y: 57.554,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 93.2391 360.5191)",
    style: {
      fill: "#CED6E0"
    },
    width: 6.4,
    height: 20.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M498.142,75.733c0-2.133-1.067-4.267-2.133-5.333c-1.067-1.067-2.133-2.133-4.267-2.133 c-4.267,2.133-7.467,4.267-8.533,8.533c0,1.067,1.067,3.2,2.133,4.267c1.067,1.067,3.2,2.133,5.333,2.133 C493.875,82.133,497.075,80,498.142,75.733z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.896,
    y: 72.256,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 78.5515 354.4177)",
    style: {
      fill: "#CED6E0"
    },
    width: 6.4,
    height: 20.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M483.209,90.667c0-2.133-1.067-4.267-2.133-5.333c-1.067-1.067-2.133-2.133-4.267-2.133 c-4.267,2.133-6.4,5.333-8.533,8.533c0,1.067,1.067,3.2,2.133,4.267c1.067,1.067,3.2,2.133,5.333,2.133 C478.942,97.067,482.142,93.867,483.209,90.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M315.742,197.333c39.467,39.467,61.867,82.133,14.933,129.067c-4.267,4.267-9.6,8.533-16,11.733 c-26.667,13.867-44.8,40.533-45.867,71.467c-1.067,25.6-10.667,48-27.733,66.133c-66.133,66.133-125.867,35.2-182.4-21.333 S-28.791,339.2,37.342,272c17.067-17.067,40.533-26.667,66.133-27.733c29.867-1.067,57.6-19.2,71.467-45.867 c3.2-5.333,6.4-10.667,11.733-16C234.675,134.4,276.275,156.8,315.742,197.333z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15C"
    },
    cx: 243.209,
    cy: 269.867,
    r: 53.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#415A6B"
    },
    cx: 243.209,
    cy: 269.867,
    r: 35.2
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD15C"
    },
    points: "254.942,227.2 285.875,258.133 440.542,90.667 422.409,72.533 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M508.809,44.8l-52.267,45.867c-4.267-4.267-11.733-4.267-16,0l-18.133-18.133 c4.267-4.267,4.267-11.733,0-16l45.867-52.267C489.609,10.667,503.475,24.533,508.809,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M117.342,310.4l-6.4,6.4c-2.133,2.133-2.133,6.4,0,9.6l75.733,75.733c2.133,2.133,6.4,2.133,9.6,0 l6.4-6.4c2.133-2.133,2.133-6.4,0-9.6L126.942,310.4C124.809,308.267,120.542,308.267,117.342,310.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F3F3"
    },
    cx: 439.475,
    cy: 55.467,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F3F3"
    },
    cx: 453.342,
    cy: 38.4,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F3F3"
    },
    cx: 467.209,
    cy: 22.4,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F3F3"
    },
    cx: 457.609,
    cy: 73.6,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F3F3"
    },
    cx: 474.675,
    cy: 59.733,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F3F3"
    },
    cx: 490.675,
    cy: 45.867,
    r: 5.333
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8EAE9"
    },
    cx: 135.475,
    cy: 334.933,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8EAE9"
    },
    cx: 149.342,
    cy: 349.867,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8EAE9"
    },
    cx: 163.209,
    cy: 363.733,
    r: 5.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8EAE9"
    },
    cx: 178.142,
    cy: 377.6,
    r: 5.333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraduate);
export default __webpack_public_path__ + "static/media/icon_graduate.bd296d6ecf883a50476cd780b2c880f4.svg";
export { ForwardRef as ReactComponent };